<template>
  <div class="set-title">
    <el-dialog
      title="条形码"
      :visible="true"
      @close="handleClose"
      width="360px"
    >
      <js-barcode
        :value="value"
        :text="text"
        :valid=true
      ></js-barcode>
    </el-dialog>
  </div>
</template>

<script>
  import JsBarcode from '@/components/JsBarcode'
  export default {
    name: "big-code",
    props: {
      value: [String, Number],
      //覆盖显示的文本
      text: [String, Number],
    },
    components: { JsBarcode },
    methods: {
      handleClose () {
        this.$options.cancel('cancel')
      }
    }
  }
</script>

<style scoped lang="less">
  .set-title {
    ::v-deep .el-dialog__header {
      text-align: center;
    }
    ::v-deep .vue-barcode-element{
      width: 100%!important;
    }
    ::v-deep .el-dialog__body{
      padding-top: 10px;
    }
    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 30px;
    }
    ::v-deep .el-input-number--medium {
      width: 100%;
    }
    ::v-deep .el-input-number.is-without-controls .el-input__inner {
      text-align: left;
    }
    .w100{
      width: 100%;
      position: relative;
      span{
        position: absolute;
        top: 0;
        right: 10px;
      }
    }
    .w50{
      display: flex;
      width: 49%;
      position: relative;
      span{
        position: absolute;
        top: 0;
        right: 10px;
      }
    }
  }
</style>
